import React from 'react';
import MapItemSelector from '../Map/MapItemSelector';
import Object from '../Icons/ObjectIcon';
import MapImageCreator from './MapImageCreator';

const MapImageSelector = () => {
    const button = (
        <>
            <div className="pl-4 pr-4">
                <Object className="h-12" />
            </div>
        </>
    );

    const popup = (
        <div className="bg-mid-blue pl-4 pt-4 pb-4 pr-2 rounded-2xl">
            <MapImageCreator />
        </div>
    );

    return (
        <MapItemSelector
            button={button}
            popup={popup}
            id='map-image'
        />
    );
};

export default MapImageSelector;

